import Swal from "sweetalert2";
export const handleDriverPasswordChange = async (driverId, {drivers, setChangingDriverPassword}) => {
    try {
        setChangingDriverPassword(driverId);

        const { value: password, dismiss } = await Swal.fire({
        title: "Change Password",
        html: `
            <div class="mb-4">
            <label for="password" class="block text-sm font-medium text-left mb-1">New Password</label>
            <input id="password" type="password" class="w-full px-3 py-2 border rounded-md" required minlength="6">
            <p class="text-xs text-gray-500 mt-1">Minimum 6 characters</p>
            </div>
            <div class="mb-4">
            <label for="confirmPassword" class="block text-sm font-medium text-left mb-1">Confirm Password</label>
            <input id="confirmPassword" type="password" class="w-full px-3 py-2 border rounded-md" required>
            </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Update Password",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#1e3a8a",
        preConfirm: () => {
            const password = document.getElementById("password").value;
            const confirmPassword =
            document.getElementById("confirmPassword").value;

            if (password.length < 6) {
            Swal.showValidationMessage(
                "Password must be at least 6 characters"
            );
            return false;
            }

            if (password !== confirmPassword) {
            Swal.showValidationMessage("Passwords do not match");
            return false;
            }

            return password;
        },
        });

        if (dismiss) return;

        // Update password
        await drivers.updateDriverPassword(driverId, password);

        await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Password updated successfully",
        confirmButtonColor: "#1e3a8a",
        });
    } catch (error) {
        console.error("Error updating password:", error);
        await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update password. Please try again.",
        confirmButtonColor: "#1e3a8a",
        });
    } finally {
        setChangingDriverPassword(null);
    }
};